import { Component, OnInit, Inject, HostListener } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { Observable } from  "rxjs";
import { debounceTime } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { ITrialService } from '../../services/Trial/trial.service.interface';
import { Router } from '@angular/router';
import { TrialRegistration } from '../../models/trialRegistration';

@Component({
  selector: 'create-account',
  templateUrl: './create-account.component.html',
  styleUrls: ['./create-account.component.scss']
})
export class CreateAccountComponent implements OnInit {

  trialForm: FormGroup;
  document: Document;
  scrollPosition: number;
  fixHeaderAt: number;
  trialService: ITrialService;
  trialData: TrialRegistration;
  shouldShowSpinner : boolean;

  constructor(private http: HttpClient, trialService: ITrialService, formBuilder: FormBuilder, @Inject(DOCUMENT) document: Document, private router: Router) { 
    this.trialService = trialService;
    this.scrollPosition = 0;
    this.document = document;
    this.fixHeaderAt = 240;


    this.trialForm = formBuilder.group({

    });
  }

  ngOnInit() {
    this.fixHeaderAt = document.documentElement.clientWidth < 660 ? 360 : 240;
    this.scrollPosition = this.document.documentElement.scrollTop;

    this.trialData = JSON.parse(localStorage.getItem("trialModel")); 

    //make sure they didn't navigate to this page without filling out application
    if (!this.trialData || !this.trialData.organizationName) {
      this.router.navigate(["/"]);
      return;
    }
    
    this.trialService.submitHubspotPartialForm(this.trialData).subscribe(hubspot => {
    });
  }

  onSubformReady(name: string, form: FormGroup) {
    this.trialForm.addControl(name, form);
    if (name == "account" && this.trialData) {
      (this.trialForm.get('account') as FormGroup).controls['usernamePrefix'].setValue(this.trialData.loginPrefix);
    }
  }

  onSubmit() {
    this.trialForm.markAsTouched();

    if (this.trialForm.valid) {
      
      let account = this.trialForm.value.account;

      this.trialData.password = account.password;
      this.trialData.confirmPassword = account.passwordConfirm;
      this.trialData.loginPrefix = account.usernamePrefix;
      this.trialData.username = account.loginId;
      this.trialData.iPadPin = account.pin;
      this.trialData.iPadPinConfirm = account.pinConfirm;
            
      this.shouldShowSpinner = true;

      this.trialService.registerTrial(this.trialData).subscribe(org => {

        this.trialService.startTrial(org.usernamePrefix).subscribe(trial => {
        }, error => {
            console.log(error);
            this.shouldShowSpinner = false;
          });

        this.trialService.submitHubspotCombinedForm(this.trialData).subscribe(hubspot => {
        });

        localStorage.clear();
        this.router.navigate(["/trialConfirmation"]);

      }, error => {
          console.log(error);
          this.shouldShowSpinner = false;
      });

    } else {
      this.markAllTouched(this.trialForm);
    }

  }

  markAllTouched(group: FormGroup) {
    var controls = Object.keys(group.controls);
    for(var i = 0; i < controls.length; i++) {
      var currentControl = group.controls[controls[i]];
      if(currentControl instanceof FormGroup) {
        this.markAllTouched(currentControl);
      } else {
        currentControl.markAsTouched();
      }
    }
  }

  @HostListener("window:scroll", [])
  onWindowScroll() {
    this.scrollPosition = this.document.documentElement.scrollTop;
  }

  @HostListener("window:resize", [])
  onWindowResize() {
    this.fixHeaderAt = document.documentElement.clientWidth < 660 ? 360 : 240;
  }

}
